import React from 'react'
import { i18n } from '../../index'
import { Mutation } from 'react-apollo'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { createNightTask, updateNightTask, fetchNightTasks } from '../../station/stationQueries'
import type { NightTask } from '../../station/stationTypes'
import css from './nightTaskForm.css'
const defaultFormData = {
  id: null,
  name: '',
}

const updateCacheOnUpdate =
  (variables) =>
  (cache: any, { data: { updateNightTask } }: any) => {
    const { stationNightTasks } = cache.readQuery({
      query: fetchNightTasks,
      variables,
    })
    cache.writeQuery({
      query: fetchNightTasks,
      variables,
      data: {
        stationNightTasks: stationNightTasks.map((item) => (item.id === updateNightTask.id ? updateNightTask : item)),
      },
    })
  }

const updateCacheOnCreate =
  (variables) =>
  (cache: any, { data: { createNightTask } }: any) => {
    const { stationNightTasks } = cache.readQuery({
      query: fetchNightTasks,
      variables,
    })
    cache.writeQuery({
      query: fetchNightTasks,
      variables,
      data: {
        stationNightTasks: [...stationNightTasks, createNightTask],
      },
    })
  }

type NightTaskFormProps = {
  data: NightTask | null | undefined
  stationId: string
  onSubmit: (...args: Array<any>) => any
  onCancel: (...args: Array<any>) => any
}
type NightTaskFormState = {
  formData: NightTask
}

class NightTaskForm extends React.Component<NightTaskFormProps, NightTaskFormState> {
  state = {
    formData: { ...defaultFormData },
  }

  componentDidMount() {
    const { data } = this.props

    if (data) {
      this.setStateFromData(data)
    }
  }

  componentDidUpdate(prevProps: NightTaskFormProps) {
    const { data } = this.props

    if (data && JSON.stringify(data) !== JSON.stringify(prevProps.data)) {
      this.setStateFromData(data)
    }
  }

  setStateFromData = (data: NightTask) => {
    this.setState({
      formData: { ...defaultFormData, ...data },
    })
  }
  onInput = (fieldName: string, newValue: string | number) => {
    this.setState({
      formData: { ...this.state.formData, [fieldName]: newValue },
    })
  }
  onSubmit = (onMutate: (...args: Array<any>) => any, e: any) => {
    e.preventDefault()
    const { stationId } = this.props
    const {
      formData: { id: nightTaskId, name },
    } = this.state
    onMutate(
      nightTaskId
        ? {
            variables: {
              nightTaskId,
              name,
            },
            update: updateCacheOnUpdate({
              stationId,
            }),
          }
        : {
            variables: {
              stationId,
              name,
            },
            update: updateCacheOnCreate({
              stationId,
            }),
          },
    )
    this.props.onSubmit()
    this.onReset()
  }
  onReset = () => {
    this.setState({
      formData: { ...defaultFormData },
    })
  }

  render() {
    const { onCancel } = this.props
    const { formData } = this.state
    return (
      <Mutation mutation={formData.id ? updateNightTask : createNightTask}>
        {(onMutate) => (
          <form noValidate onSubmit={(e) => this.onSubmit(onMutate, e)} className={css.component}>
            <TextField
              autoFocus
              required
              label={i18n.t('admin.stations.label.nightTaskName')}
              value={formData.name}
              onChange={(e) => this.onInput('name', e.target.value)}
              className={css.textField}
            />
            <DialogActions className={css.actions}>
              <Button type='button' onClick={onCancel}>
                {i18n.t('buttons.cancel')}
              </Button>
              <Button type='submit' color='primary'>
                {i18n.t('buttons.save')}
              </Button>
            </DialogActions>
          </form>
        )}
      </Mutation>
    )
  }
}

export default NightTaskForm
